import { useCallback } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';

import useWebhooks from '@/hooks/useWebhooks';
import { selectBrainId } from '@/redux/session/selectors';
import { WebhookType, type PreNbaWebhookTest, type WebhookTest } from '@/shared/types/webhook';

import WebhookConfigCard from '../components/WebhookConfigCard';
import type { WebhookWizardFormValues } from '../wizardForm';

export const SetupWebhookStep = () => {
  const brainId = useSelector(selectBrainId);
  const resolvedBrainId = brainId ?? '';
  const { testWebhook, testStatus, testResults } = useWebhooks(resolvedBrainId);
  const { control } = useFormContext<WebhookWizardFormValues>();
  const webhookType = useWatch({ control, name: 'type' }) ?? WebhookType.ACTION;

  const handleRunTest = useCallback(
    (payload: WebhookTest | PreNbaWebhookTest) => {
      if (!resolvedBrainId) {
        return;
      }

      testWebhook(payload);
    },
    [resolvedBrainId, testWebhook]
  );

  return (
    <div className="m-w-[1280px] h-[570px]">
      <WebhookConfigCard
        className="h-[570px]"
        onTest={resolvedBrainId ? handleRunTest : undefined}
        isTesting={testStatus === 'pending'}
        testResults={testResults ?? null}
        isCreateMode={true}
        webhookType={webhookType}
      />
    </div>
  );
};
